.sidebar-secondary-button{width:189px;height:29px!important;justify-content:left;margin-top:3.5px;margin-bottom:3.5px}
/*# sourceMappingURL=sidebar-secondary-button.component-4B6SWBZV.css.map */
